// Generated file - do not change manually!

/**
 * Defines where the <code>ui5-toast</code> will be placed.
 */
export enum ToastPlacement {
  /**
   * <code>ui5-toast</code> is placed at the <code>BottomCenter</code> position of its container. Default placement (no selection)
   */
  BottomCenter = 'BottomCenter',

  /**
   * <code>ui5-toast</code> is placed at the <code>BottomEnd</code> position of its container.
   */
  BottomEnd = 'BottomEnd',

  /**
   * <code>ui5-toast</code> is placed at the <code>BottomStart</code> position of its container.
   */
  BottomStart = 'BottomStart',

  /**
   * <code>ui5-toast</code> is placed at the <code>MiddleCenter</code> position of its container.
   */
  MiddleCenter = 'MiddleCenter',

  /**
   * <code>ui5-toast</code> is placed at the <code>MiddleEnd</code> position of its container.
   */
  MiddleEnd = 'MiddleEnd',

  /**
   * <code>ui5-toast</code> is placed at the <code>MiddleStart</code> position of its container.
   */
  MiddleStart = 'MiddleStart',

  /**
   * <code>ui5-toast</code> is placed at the <code>TopCenter</code> position of its container.
   */
  TopCenter = 'TopCenter',

  /**
   * <code>ui5-toast</code> is placed at the <code>TopEnd</code> position of its container.
   */
  TopEnd = 'TopEnd',

  /**
   * <code>ui5-toast</code> is placed at the <code>TopStart</code> position of its container.
   */
  TopStart = 'TopStart'
}
